import { forwardRef, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import { useMutation, useQueryClient } from 'react-query';
import { UserApi } from '../../api/User';
import styles from './CardTypeModal.module.css';

type Option = { value: string; label: string };

interface Props {
  options: Option[];
  current: number | undefined;
  requiredAgreementsAccepted: boolean;
}

export type CardTypeModalRef = {
  open: () => void;
  close: () => void;
};


export const CardTypeModal = forwardRef<CardTypeModalRef, Props>(
  ({ options, current, requiredAgreementsAccepted }, ref) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState<string>(current != null ? String(current) : '0');
    const qc = useQueryClient();

    // wyświetl tylko opcje > 0
    const visibleOptions = Array.isArray(options)
      ? options.filter(o => String(o.value) !== '0')
      : [];

    useImperativeHandle(ref, () => ({
      open: () => setOpen(true),
      close: () => setOpen(false),
    }));

    const { mutate, isLoading } = useMutation(
      (v: string) => UserApi.editCardType(Number(v)),
      {
        onSuccess: () => {
          qc.invalidateQueries('user');
          setOpen(false);
        },
      }
    );

    // blokada zmiany wstecznej (2 -> 1)
    const isDisabled = (optVal: string) => current === 2 && optVal === '1';

    if (!open) return null;

    return (
      <div className={styles.backdrop}>
        <div className={styles.modal}>
          <h3>Wybierz typ legitymacji</h3>

          {!requiredAgreementsAccepted && (
            <p className={styles.warn}>
              Najpierw zaakceptuj wymagane zgody, a potem wybierz typ legitymacji.
            </p>
          )}

          <div className={styles.list}>
            {visibleOptions.map(opt => (
              <label key={opt.value} className={styles.option}>
                <input
                  type="radio"
                  name="card_type"
                  value={opt.value}
                  checked={value === opt.value}
                  onChange={e => setValue(e.target.value)}
                  disabled={isDisabled(opt.value)}
                />
                <span>{opt.label}</span>
              </label>
            ))}
          </div>

          <div className={styles.actions}>
            <button
              className={styles.btnPrimary}
              disabled={!requiredAgreementsAccepted || value === '0' || isLoading}
              onClick={() => mutate(value)}
            >
              Zapisz
            </button>
          </div>
        </div>
      </div>
    );
  }
);